/* eslint-disable @next/next/no-img-element */
import { cn } from '@aw/lib'

interface OlameeLogoProps {
    /** Sizing/positioning classes applied to the rendered logo (e.g. `h-9 w-auto`). */
    className?: string
}

/**
 * Olamee brand logo with automatic light/dark swap (AWOPS-3290).
 *
 * The gradient wordmark is identical in both files; only the "powered by" sub-text
 * color differs — #2F3C4D (light) vs #fbfbfc (dark) — so we swap the whole SVG by
 * theme via CSS. Dark is org-only (next-themes `.dark`); light apps never match
 * `dark:`, so they always render the light file.
 */
export const OlameeLogo = ({ className }: OlameeLogoProps) => (
    <>
        <img src="/images/olamee-logo.svg" alt="Olamee" className={cn('dark:hidden', className)} />
        <img src="/images/olamee-logo-dark.svg" alt="Olamee" className={cn('hidden dark:block', className)} />
    </>
)

export default OlameeLogo
